import { Link } from "@resource/atlas";
import {
  GetOpenJobs_openJobs as Job,
  JobRoleGuideTemplateSetupStatus,
} from "generated/schemaTypes";
import { analytics } from "react-hooks/useAnalytics";
import { UseTableCellProps } from "react-table";

function SetupActionCell(props: UseTableCellProps<Job>) {
  const { row } = props;

  const { id, setupStatus } = row.original;

  if (setupStatus === JobRoleGuideTemplateSetupStatus.SETUP_COMPLETE) {
    return <></>;
  }

  return (
    <Link
      className="float-right"
      href={`/jobs/${id}/setup?returnToJobsList=true`}
      onClick={() =>
        analytics.track("Job Setup Wizard - Started", {
          project: "New job setup workflow",
          button: "table",
          continue: setupStatus !== "NOT_SETUP",
        })
      }
    >
      {setupStatus === "NOT_SETUP" ? "Set up job" : "Finish setup"}
    </Link>
  );
}

export default SetupActionCell;
